import React, { useRef, useState } from "react";
import PrimaryLoader from "../common/PrimaryLoader/index.jsx";
import Pagination from "../pagination/index.jsx";
import { debounce } from "lodash";
import useGetTodaysPunches from "../../pages/todays_attendance/useGetTodaysPunches";
import RoundedContainer from "../containers/RoundedContainer.jsx";
import SearchBar from "../inputs/SearchBar.jsx";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../table/Table.jsx";

const TodayAttendanceList = () => {
  const { data, isLoading, handleSearch, handlePagination, paginationInfo } =
    useGetTodaysPunches();

  const [searchValue, setSearchValue] = useState("");

  const debouncedSearch = useRef(
    debounce((value) => {
      handleSearch(value);
    }, 300)
  ).current;

  const handleInputSearch = (e) => {
    setSearchValue(e.target.value);
    debouncedSearch(e.target.value);
  };

  const handlePageClick = (val) => {
    handlePagination(val.selected);
  };

  return (
    <>
      <RoundedContainer>
        <div className="w-[400px]">
          <SearchBar value={searchValue} onChange={handleInputSearch} />
        </div>
      </RoundedContainer>
      {isLoading ? (
        <div className="w-16 h-16 mx-auto my-20">
          <PrimaryLoader />
        </div>
      ) : (
        <>
          <RoundedContainer className="overflow-hidden">
            {data.length > 0 ? (
              <Table>
                <TableHead>
                  <TableHeaderCell>Name</TableHeaderCell>
                  <TableHeaderCell>Status</TableHeaderCell>
                  <TableHeaderCell>Punch Time</TableHeaderCell>
                </TableHead>
                <TableBody>
                  {data.map((item) => {
                    const {
                      company_employee_id,
                      employee_name,
                      punch_status,
                      punch_time,
                    } = item;
                    return (
                      <TableRow key={company_employee_id}>
                        <TableCell className="text-dark font-medium">
                          {employee_name}
                        </TableCell>
                        <TableCell className="text-dark font-medium text-base">
                          <span
                            className={`${
                              punch_status === "Present"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            } text-sm px-2 py-1`}
                          >
                            {punch_status}
                          </span>
                        </TableCell>
                        <TableCell className="text-dark font-medium text-base">
                          {punch_status !== "Absent" ? (
                            <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded break-words">
                              {punch_time}
                            </div>
                          ) : (
                            <span className="text-gray-500">-</span>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <div className="text-center text-dark py-20">
                No attendance records found.
              </div>
            )}
          </RoundedContainer>

          <RoundedContainer className={"mb-10"}>
            <Pagination
              lengthofItems={paginationInfo.totalCount}
              limit={paginationInfo.perPage}
              currentPage={paginationInfo.currentPage}
              onPageChange={handlePageClick}
            />
          </RoundedContainer>
        </>
      )}
    </>
  );
};

export default TodayAttendanceList;
